import React from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';

import Star from '../../../../svg/star_shaddow.svg';
import Arrow from '../../../../svg/arr_right_top.svg';

const AboutServices = ({ servicesData, servicesCategory }) => {
  const langToggle = useLanguage;
  return (
    <section className="about-services" data-scroll-section>
      <div className="content-wrapper">
        <div className="default-info__header">
          <span className="default-info__header-marker">
            {langToggle(servicesData.marker_ua, servicesData.marker_ru)}
          </span>
          <h2 className="default-info__header-title">
            {langToggle(servicesData.title_ua, servicesData.title_ru)}
          </h2>
        </div>
        <ul className="home-services__items">
          {servicesCategory.Services.map((item, index) => {
            const count = ++index;
            // const speed =
            //   index === 0 ? 4 : index === 1 ? 3 : index === 2 ? 2 : 1;
            return (
              <li
                className="home-services__item"
                key={index}
                // data-scroll=""
                // data-scroll-speed={speed}
                // data-scroll-position="top"
              >
                <Link to={'/' + item.link} className="home-services__item-link">
                  <span className="home-services__link-counter">
                    {'0' + count + '.'}
                  </span>
                  <span className="home-services__link-titles__wrapper">
                    <span className="home-services__link-description">
                      {langToggle(item.description_ua, item.description_ru)}
                    </span>
                    <span className="home-services__link-title">
                      {langToggle(item.title_ua, item.title_ru)}
                      <Arrow className="home-services__link-arrow__sm" />
                    </span>
                  </span>
                  <span className="home-services__link-icon">
                    <Star className="home-services__link-icon__star" />
                    <Arrow className="home-services__link-icon__arrow" />
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

AboutServices.propTypes = {
  servicesData: PropTypes.object,
};

export default AboutServices;
